export default "__VITE_ASSET__9nKJD3$$__"